module.exports = __webpack_public_path__ + "img/riskmanagement-min.43b72351.jpg";